<template>


  <b-modal
      id="modal-quote-occurrence-resume"
      ref="modal"
      title="Resumo de Serviços por Item"
      size="lg"
      @show="showModal"
      @hidden="resetModal"
      no-close-on-backdrop
      no-close-on-esc
      no-enforce-focus>


    <div v-if="!busy">


          <div class="row">
            <div class="col-12">


              <t-table table-bordered table-striped
                       class="ml-3 mb-2"
                       :items="form"
                       :fields="fields"
                       primary-key-column="typeChecklistItem"
                       link-primary-column="typeChecklistItem"
                       disable-link-primary-column disable-actions-column
              ></t-table>
              <div class="d-flex justify-content-between border-top pt-2">
                <div>Valor Total Serviços</div>
                <strong style="font-size: 16px">{{ totalOccurrences | money}}</strong>
              </div>

            </div>
          </div>







    </div>

    <template #modal-footer="{ ok }">

      <t-button @click="ok()" text="Ok"/>

    </template>



  </b-modal>



</template>
<script>
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import UnitType from "@/model/types/modules/general/UnitType";
import http from "@/services/config/http-common";
import ui from "@/assets/scripts/ui";


export default {
  name: 'QuoteOccurrenceResumeByItemDialog',
  mixins: [pageDialogFormMixin],
  data() {
    return {
      UnitType,
      id: "modal-quote-occurrence-resume",
      path: "business/quote/getResumeOccurrencesByCategories", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "quoteOccurrenceId",
      foreignKeyColumn: "quoteId", //Utilizar quando usar Tabs com outros componentes
      form: {
        quoteId:0,
      },
      fields:[
        {key: "typeChecklistItem", label: "Serviço"},
        {key: "unit", label: "Un."},
        {key: "categoryQuantity", label: "Qtd. Total", formatter: "number"},
        {key: "categoryPriceSale", label: "Valor Total", formatter: "money"}
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

    }
  },
  props: {
    customerId: {
      type: Number,
      required: false,
      default: 0,
    },
    companyId: {
      type: Number,
      required: false,
      default: 0,
    },
    totalOccurrences:{
      type: Number,
      required: false,
      default: 0,
    }
  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      this.busy = true

      //Limpa os campos
      this.resetModal()

      this.form.quoteId = this.foreignKey

      await http.get(this.path + '/' + this.form.quoteId).then(response => {

        this.form = response.data

      }).catch(error => ui.generalResponseError(this, error))


      this.busy = false

    },

    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela



    //--------------------------------------------------------------------------------------
  },
}
</script>
